import { createAction, props } from '@ngrx/store';

export const LoadSearchedClassifications =
 createAction('[Classification Search Effect] Load Searched Classifications', props<{payload: any}>());
export const LoadSearchedClassificationsSuccess =
 createAction('[Classification Search Effect] Load Searched ClassificationsSuccess', props<{payload: any}>());
export const DeleteSearchedClassificationsSuccess =
 createAction('[Classification Search Effect] Delete Searched ClassificationsSuccess', props<{payload: any}>());
export const SendSearchedClassification =
 createAction('[Classification Search Effect] Send Searched Classification', props<{payload: any}>());
export const SendSearchedClassificationSuccess =
 createAction('[Classification Search Effect] Send Searched Classification Success', props<{payload: any}>()); 

 export const SendSearchedClassificationPrediction =
 createAction('[Classification Search Effect] Send Searched Classification Prediction', props<{payload: any}>());
 export const SendSearchedClassificationPredictionSuccess =
 createAction('[Classification Search Effect] Send Searched Classification Prediction Success', props<{payload: any}>());

 export const SendSearchedClassificationE2E =
 createAction('[Classification Search Effect] Send Searched Classification E2E', props<{payload: any}>());

 export const SendSearchedClassificationE2ESoleProprietor  =
 createAction('[Classification Search Effect] Send Searched Classification E2E SoleProprietor', props<{payload: any}>());

 export const SendSearchedClassificationE2EPartner  =
 createAction('[Classification Search Effect] Send Searched Classification E2E Partner', props<{payload: any}>()); 

 export const SendSearchedClassificationE2EHomeOwner  =
 createAction('[Classification Search Effect] Send Searched Classification E2E HomeOwner', props<{payload: any}>());